import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/logo.png'; // Import your logo image

// Styled components for the navigation bar
const NavContainer = styled.nav`
  background-color: #2089AC; /* Dark blue background */
  padding: 0 20px; /* Remove top and bottom padding */
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  position: relative;
  height: 70px; /* Set a fixed height for the navbar */
  z-index: 1000; /* Ensure the navbar is above other elements */
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;

  img {
    height: 80%; /* Adjust the height of the logo relative to the navbar */
    width: auto;
    max-height: 50px; /* Optional: Set a max height for the logo */
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1); /* Slight zoom effect on hover */
    }
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #2089ac;
    padding: 10px 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000; /* Ensure the mobile menu is above other elements */
  }
`;

const NavLink = styled(Link)`
  color: #ecf0f1; /* Light gray text */
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #2c3e50; /* Blue background on hover */
    color: white;
    transform: translateY(-2px); /* Slight lift effect */
  }

  &:active {
    transform: translateY(0); /* Reset lift effect on click */
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 10px 0;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
  }

  div {
    width: 25px;
    height: 3px;
    background-color: #ecf0f1;
    margin: 4px 0;
    transition: all 0.3s ease;
    transform-origin: center;

    &:nth-child(1) {
      transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none')};
    }

    &:nth-child(2) {
      opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
    }

    &:nth-child(3) {
      transform: ${({ isOpen }) => (isOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none')};
    }
  }
`;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <NavContainer>
      {/* Brand/Logo on the left side */}
      <Brand>
        <Link to="/">
          <img src={logo} alt="MINES D'AMEZMIZ Logo" />
        </Link>
      </Brand>

      {/* Hamburger menu for mobile */}
      <Hamburger onClick={toggleMenu} isOpen={isOpen}>
        <div />
        <div />
        <div />
      </Hamburger>

      {/* Navigation links */}
      <NavLinks isOpen={isOpen}>
        <NavLink to="/" onClick={() => setIsOpen(false)}>Accueil</NavLink>
        <NavLink to="/products" onClick={() => setIsOpen(false)}>Produits</NavLink>
        <NavLink to="/contact" onClick={() => setIsOpen(false)}>Contact</NavLink>
      </NavLinks>
    </NavContainer>
  );
};

export default Navigation;